import React, { Component } from 'react';
import 'HELPDESK/Components/QueryDetails/AddRequestModal/DesignRequest/designrequest.css';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import config from 'config';
import { Base64 } from 'js-base64';
import axios from 'axios';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
export class DesignRequest extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      serviceRequestTitle: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].querySubject : '',
      explanation: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].queryDescription : '',
      moduleId: this.props.selectedModuleId,
      subModuleId: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].subModuleId : '',
      moduleName: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].moduleName : '',
      subModuleName: '',
      selectedModuleName: this.props.selectedModuleName,
      modulesFetching: false,
      subscriptionModuleList: {},
      moduleList: {},
      attachments: [],
      error: {
        serviceRequestTitleWarning: '',
        explanation: '',
        moduleWarning: '',
        subModuleWarning: '',
      },
      addingDesign: false,
      viewAttachment: false,
      selectedAttachment: '',
      selectedAttachmentPath: '',
      selectedAImageExtensions: "",
      previousAttachmentFileNameArray: this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].attachments : [],




    };

  }
  componentDidMount() {
    this.apiCallToGetSubModuleList()
    this.apiCallToSubscriptionModuleList();
  }


  // API METHOD CALL TO GET MODULE LIST
  apiCallToGetSubModuleList = async () => {
    this.setState({
      modulesFetching: true
    });

    let requestData = {
      module_id: this.state.moduleId,
    }
    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'getHelpDeskSubModulesList',
      requestData,
      '/api/helpDesk/employee/Queries.php'
    );


    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToGetSubModuleList()
      }, 1000);
    } else {
      if (jsonResponse.success) {

        let apiResult = jsonResponse.APIResult.data;

        this.setState({
          moduleList: apiResult,
          modulesFetching: false,
        });
      } else {
        this.setState({
          modulesFetching: false,
          // successModalType: 'error',
          // successMessage: 'Something went wrong while getting module list. Please try again later.'
        });

      }
    }
  }

  apiCallToSubscriptionModuleList = async () => {
    let requestData = {
      "iid": config.institute_id,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'GetHelpDeskModuleList',
      requestData,
      '/api/helpDesk/employee/moduleInformation.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToSubscriptionModuleList()
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult.data;

        this.setState({
          subscriptionModuleList: apiResult,
        });
      } else {
        this.setState({
          successModal: true,
          successModalType: 'error',
          successMessage: 'Something went wrong while getting subscription module list. Please try again later.'
        });
      }
    }
  }

  apiCallToAddDesignRequest = async () => {
    this.setState({
      addingDesign: true,
    })

    try {
      let userId = config.faculty_id;
      let formData = new FormData();
      const requestData = {
        "userRole": "Instructor",
        "iid": config.institute_id,
        "userUid": userId,
        "querySubject": this.state.serviceRequestTitle,
        "queryDescription": this.state.explanation,
        "queryType": "designs",
        "moduleId": this.state.moduleId,
        "moduleName": this.state.selectedModuleName,
        // "targetElement": this.state.selectedTargetElements.map((element) => element.value).join(","),
        // "Query_occurred_in": this.state.queryOccurrence,
        // "subModuleId": this.state.subModuleId,
        "acYr": config.instructorInfo.AcaYearId,
        "accountType": "",

        "attachmentFileArray": this.state.attachments.reduce((acc, item) => {
          acc.push({ [item.name]: "" }); // Correct usage of computed property names
          return acc;
        }, []),

        "teamName": "Design Team"


      }


      // debugger;
      formData.append('helpDesk_addClientServiceRequest', true);
      formData.append('data', Base64.encode(JSON.stringify(requestData)));


      let parameterData = {
        source: 'app',
        uid: config.faculty_id,
        email: config.emailId,
        role: 'instructor'
      };
      formData.append('tokenInputParameter', Base64.encode(JSON.stringify(parameterData)));

      this.state.attachments.forEach((attachment) => {
        if (attachment.file) {
          formData.append('file[]', attachment.file);
        } else {
          console.error("File object is missing for attachment:", attachment);
        }
      });

      const headers = {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        "Authorization": "Basic " + config.user_token
      };

      // Send the API request
      const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });
      // Handle the API response
      let jsonResponse = response.data;
      if (jsonResponse.status === 'success') {
        this.setState({ addingDesign: false });
        toast.success(jsonResponse.message);
        this.props.onCloseModal();
      } else {
        toast.error(jsonResponse.message)
        this.setState({ addingDesign: false });
        this.props.onCloseModal();
      }
    } catch (error) {
      toast.error('Something went wrong while adding design Request count. Please try again later.')
      this.setState({ addingDesign: false });
      // this.props.onCloseModal();
    }
  };

  // RE RAISE SR 
  apiCallToReRaiseDesignRequest = async () => {
    this.setState({
      addingDesign: true,
    })

    try {
      let userId = config.faculty_id;
      let formData = new FormData();
      const requestData = {
        "userRole": "Instructor",
        "iid": config.institute_id,
        "userUid": userId,
        "querySubject": this.state.serviceRequestTitle,
        "queryDescription": this.state.explanation,
        "queryType": "designs",
        "moduleId": this.state.moduleId,
        "moduleName": this.state.selectedModuleName,
        "acYr": config.instructorInfo.AcaYearId,
        "accountType": "",
        "attachmentFileArray": this.state.attachments.reduce((acc, item) => {
          acc.push({ [item.name]: "" }); // Correct usage of computed property names
          return acc;
        }, []),
        "previousAttachmentFileNameArray": this.state.previousAttachmentFileNameArray,
        "sr_unique_id": Object.values(this.props.currentClientResponse)[0].serviceRequestId,

        "teamName": "Design Team"


      }


      // debugger;
      formData.append('helpDesk_reopenClientServiceRequest', true);
      formData.append('data', Base64.encode(JSON.stringify(requestData)));


      let parameterData = {
        source: 'app',
        uid: config.faculty_id,
        email: config.emailId,
        role: 'instructor'
      };
      formData.append('tokenInputParameter', Base64.encode(JSON.stringify(parameterData)));

      this.state.attachments.forEach((attachment) => {
        if (attachment.file) {
          formData.append('file[]', attachment.file);
        } else {
          console.error("File object is missing for attachment:", attachment);
        }
      });

      const headers = {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        "Authorization": "Basic " + config.user_token
      };

      // Send the API request
      const response = await axios.post(config.RootUrl + '/api/helpDesk/clientServiceRequest/help_deskClientServiceRequest.php', formData, { headers });
      // Handle the API response
      let jsonResponse = response.data;
      if (jsonResponse.status === 'success') {
        this.setState({ addingDesign: false });
        toast.success(jsonResponse.message);
        this.props.onCloseModal();
      } else {
        toast.error(jsonResponse.message)
        this.setState({ addingDesign: false });
        this.props.onCloseModal();
      }
    } catch (error) {
      toast.error('Something went wrong while updating design Request count. Please try again later.')
      this.setState({ addingDesign: false });
      // this.props.onCloseModal();
    }
  };
  validateAddDesignRequest = () => {
    let isValid = true;
    if (this.state.serviceRequestTitle === '') {
      isValid = false;
      // serviceRequestTitleWarning
      this.setState((prevState) => ({
        error: {
          ...prevState.error,
          serviceRequestTitleWarning: 'Design Request Title is required'
        }
      }))
    }
    if (this.state.explanation === '') {
      isValid = false;
      this.setState((prevState) => ({
        error: {
          ...prevState.error,
          explanation: 'Description is required'
        }
      }));

    }

    if (isValid) {
      if (this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0) {
        this.apiCallToReRaiseDesignRequest();
      } else {
        this.apiCallToAddDesignRequest();

      }
    } else {
      toast.error('Please fill all required fields');
    }

  }



  // Trigger file input on button click
  handleAddAttachmentClick = () => {
    this.fileInputRef.current.click();
  };

  // Handle file upload
  handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map((file, index) => ({
      id: Date.now() + index,
      name: file.name,
      file: file, // Store the actual file object
    }));
    // setAttachments([...attachments, ...newAttachments]); in clss components
    this.setState((prevState) => ({
      attachments: [...prevState.attachments, ...newAttachments]
    }));

  };


  // REMOVE ATTACHMENT
  handleDeleteAttachment = (id) => {
    // setAttachments(attachments.filter((attachment) => attachment.id !== id));class components
    this.setState((prevState) => ({
      attachments: prevState.attachments.filter((attachment) => attachment.id !== id)
    }));
  };
  closeSuccessModal = () => {
    this.setState({
      successModal: false,
    });
  }


  // METHOD TO GET MODULE
  getModule = (e) => {
    this.setState({
      moduleId: e.target.value
    }, () => this.apiCallToGetAddSubModuleList());

    if (e.target.value.length < 1) {
      this.setState({
        moduleWarning: 'Please select module.',
        moduleName: ''
      });
    } else {
      this.setState({
        moduleWarning: '',
        moduleName: e.target.selectedOptions[0].text
      });
    }
  }
  viewAttachmentClick = (attachment) => {
    this.setState({
      viewAttachment: true,
      selectedAttachmentPath: Object.values(this.props.currentClientResponse)[0].attachmentPath,
      selectedAttachment: attachment.fileName,
      selectedAImageExtensions: attachment.fileName.split('.').pop()
    });
  };


  returnViewAttachment = () => {
    let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
    return (
      <div className={this.state.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer">

        <div className="modal-dialog modal-dialog-centered modal-xl viewAttachmentDialog">
          <div className="modal-content viewAttachmentContent">
            <div className="modal-header">
              <div className="icon-container">
                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
              </div>
              <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</h3>
              <FontAwesomeIcon
                icon={['fas', 'times']}
                style={{ cursor: 'pointer' }}
                size="lg"
                color="#000000"
                onClick={() => this.setState({ viewAttachment: false })} // Close the modal
              />
            </div>
            <div className="modal-body viewAttachment-body">
              {
                imageExtensions.includes(this.state.selectedAImageExtensions) ?
                  <div>
                    <img src={this.state.selectedAttachmentPath + '/' + this.state.selectedAttachment} alt='attachmentimg' width='100%' height='100%' />
                  </div>
                  :
                  <iframe title='attachmentPath' src={this.state.selectedAttachmentPath + '/' + this.state.selectedAttachment} alt="attachment" width='100%' height='100%' />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }

  // DELETEPREVIOUS ATTACHMENT
  deletePreviousAttachment = (index) => {
    let previousAttachmentFileNameArray = this.state.previousAttachmentFileNameArray;
    previousAttachmentFileNameArray.splice(index, 1);
    this.setState({ previousAttachmentFileNameArray });
  }
  render() {
    return (
      <div className='design-request'>

        <div className="design-request-modal-body">

          {/* <div className="design-request-form-group">
            <label>Service Consumption Percentage</label>
            <p className="percentage">12% Consumed Customization.</p>
          </div> */}
          <div className="form-group design-request-form-group">
            <p className='vm_custom_body5' style={{ color: '#000000' }}>Module <span style={{ color: 'red' }}>*</span></p>
            <select
              disabled={true}
              style={{ fontSize: "14px" }}
              className="form-control"
              value={this.state.moduleId}
              onChange={(e) => this.getModule(e)}
            >
              <option style={{ fontSize: "14px" }} value="">Select Module</option>
              {
                Object.keys(this.state.subscriptionModuleList).length > 0 &&
                Object.values(this.state.subscriptionModuleList).map(module => {
                  return (
                    <option key={module.moduleId} value={module.moduleId}>{module.module_name}</option>
                  );

                })
              }
            </select>
            <p className="text-danger" style={{ fontSize: 13 }}>{this.state.moduleWarning}</p>
          </div>


          {/* <div className="form-group design-request-form-group">
            <p className='vm_custom_body5' style={{ color: '#000000' }}>Sub Module <span className="required">*</span></p>
            <select style={{ fontSize: '14px',fontFamily:'Poppins' }} className="form-control"
              // Value and onchange
              value={this.state.subModuleId}
              onChange={(e) => this.setState({ subModuleId: e.target.value })}
            >


              <option className='request-form-size' style={{ fontSize: '14px',fontFamily:'Poppins' }}>Select sub module name</option>
              {
                Object.keys(this.state.moduleList).length > 0 &&
                Object.values(this.state.moduleList).map(module => {
                  return (
                    <option style={{ fontSize: "14px" ,fontFamily:'Poppins'}} key={module.uniqueId} value={module.uniqueId}>
                      {module.subModuleName}
                    </option>
                  );
                })
              }
            </select>
            <p className="text-danger" style={{ fontSize: 13 }}>{ }</p>
          </div> */}

          <div className="form-group design-request-form-group">
            <p className='vm_custom_body5' style={{ color: '#000000' }}>Service Request Title<span style={{ color: 'red' }}>*</span></p>
            <input type="text" style={{ height: '40px' }} name="title" className='form-control title-form-control' placeholder="Enter problem statement" value={this.state.serviceRequestTitle} onChange={(e) => this.setState({ serviceRequestTitle: e.target.value })} />
            <p className="text-danger" style={{ fontSize: 14 }}>
              {this.state.error.serviceRequestTitleWarning}
            </p>
          </div>
          <div className="form-group design-request-form-group">
            <p className='vm_custom_body5' style={{ color: '#000000' }}>Description <span style={{ color: 'red' }}>*</span></p>
            <textarea name="explanation" className='form-control description-form-control' placeholder="Enter explanation" value={this.state.explanation} onChange={(e) => this.setState({ explanation: e.target.value })}></textarea>
            <p className="text-danger" style={{ fontSize: 14 }}>
              {this.state.error.explanation}
            </p>

          </div>




          <div className="attachment-section">
            {this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 &&
              <div className="attachment-list">
                <p className='vm_custom_body5' style={{ color: '#000000' }}>Previous Attachments</p>
                {this.props.currentClientResponse && Object.values(this.props.currentClientResponse).length > 0 ? Object.values(this.props.currentClientResponse)[0].attachments.map((attachment, index) => (
                  <div title={'view image'} style={{ cursor: 'pointer' }} key={index} className="request-attachment-item" onClick={() => this.viewAttachmentClick(attachment)}>
                    <span className='vm_custom_body5'>{attachment.fileName}</span>
                    <FontAwesomeIcon icon={faTrash} className="delete-icon" onClick={() => this.deletePreviousAttachment(index)} />
                  </div>
                )) : (
                  <p>No previous attachments found.</p>
                )}
              </div>}
            <p className='vm_custom_body5' style={{ color: '#000000' }}>Attachment  <span style={{ color: 'red' }}>*</span></p>
            <div className="executive-attachment-upload">
              <div className='admin-upload-box'>
                <div className="error-pre-upload-box">
                  <p className='vm_custom_body10'>Choose files or drag and drop here.</p>
                  <button
                    onClick={this.handleAddAttachmentClick}
                    className="executive-browse-button text-center"

                  >
                    <p className='vm_custom_body10' style={{ color: '#FFFFFF' }}> Browse File</p>
                  </button>
                  <input
                    type="file"
                    // multiple
                    ref={this.fileInputRef}
                    style={{ display: "none" }}
                    onChange={this.handleFileUpload}
                  />
                </div>



              </div>
              <div className="attachment-list">
                <p className='vm_custom_body5' style={{ color: '#000000' }}>Attachment List</p>
                {this.state.attachments.map((attachment, index) => (
                  <div key={index} className="request-attachment-item">
                    <span>{attachment.name}</span>
                    <FontAwesomeIcon icon={faTrash} className="delete-icon" onClick={() => this.handleDeleteAttachment(index)} />
                  </div>
                ))}
              </div>

            </div>

          </div>

          <p className="text-danger" style={{ fontSize: 13 }}>{ }</p>
        </div>

        <div className='modal-footer executive-response-footer'>
          <button className='executive-custom-button executive-assign-btn' onClick={() => this.validateAddDesignRequest()}
            disabled={this.state.addingDesign}
          >
            {this.state.addingDesign ? (
              <span className="spinner-border spinner-border-sm text-grey" role="status" aria-hidden="true"></span>
            ) : (
              "Add"
            )}
          </button>
          <button className='executive-custom-button executive-cancel-btn' onClick={() => this.props.onCloseModal()}>Cancel</button>


        </div>
        {
          this.state.successModal &&
          <SuccessModal
            successModal={this.state.successModal}
            successModalType={this.state.successModalType}
            successMessage={this.state.successMessage}
            closeSuccessModal={this.closeSuccessModal}
          />
        }
        {
          this.state.viewAttachment &&
          this.returnViewAttachment()
        }

      </div>
    )
  }
}

export default DesignRequest
